// extracted by mini-css-extract-plugin
export default {"container":"lCNtfrv0Yl1515mp80Nq","text":"MsJv7yqpdKAu0nImvqB2","button":"fZS3YkZe487RTF4qtr1i"};